module.exports = __webpack_public_path__ + "fonts/input.ba5b9ac1.ttf";